/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'editor-common-extensibility-extension-lozenge-editToggle.done.editing': 'Bearbeitung abgeschlossen',
  'editor-common-extensibility-extension-lozenge-editToggle.make.edits': 'Änderungen vornehmen',
  'editor-common-extensibility.macro.button.configure': '{macroName} konfigurieren',
  'editor.extension.legacyContentHeader': 'Veralteter Inhalt',
  'editor.extension.legacyContentHeader.contentHasLimitedFunctionality': 'Dieser Inhalt hat eingeschränkte Funktionen',
  'editor.extension.legacyContentHeader.learnMore': 'Weitere Informationen',
  'editor.trackChanges.toolbarIconLabel': 'Änderungen verfolgen',
  'fablric.editor.viewAllInserts': 'Alle Einfügungen anzeigen',
  'fabric.editor.action': 'Aufgabe',
  'fabric.editor.action.description': 'Aufgaben erstellen und zuweisen',
  'fabric.editor.addAltText': 'Alternativtext',
  'fabric.editor.addColumnLeft': 'Spalte links hinzufügen',
  'fabric.editor.addColumnRight': 'Spalte rechts hinzufügen',
  'fabric.editor.addCommentOnMedia': 'Kommentar hinzufügen',
  'fabric.editor.addImageBorder': 'Rahmen hinzufügen',
  'fabric.editor.addLoomVideo': 'Loom-Video aufnehmen',
  'fabric.editor.addLoomVideoComment': 'Einen Loom-Videokommentar aufnehmen',
  'fabric.editor.addMediaFiles': 'Bild, Video oder Datei hinzufügen',
  'fabric.editor.addRowAbove': 'Zeile oberhalb hinzufügen',
  'fabric.editor.addRowBelow': 'Zeile unterhalb hinzufügen',
  'fabric.editor.addUpdatedAltText': 'Alternativtext hinzufügen',
  'fabric.editor.ai.ai-panels.actionItemsPageDescription':
    'Atlassian Intelligence kann Aufgaben suchen und sie in einem Panel anzeigen.',
  'fabric.editor.ai.ai-panels.actionItemsPageTitle': 'Aufgaben-Panel (Betaversion)',
  'fabric.editor.ai.ai-panels.summarizePageDescription':
    'Atlassian Intelligence kann diese Seite zusammenfassen und sie in einem Panel anzeigen.',
  'fabric.editor.ai.ai-panels.summarizePageTitle': 'Panel für Seitenzusammenfassung (Betaversion)',
  'fabric.editor.ai.ai-smart-button.context.reference': 'Ausgewählter Inhalt',
  'fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription':
    'Erstellt Inhalte, die dem Update hinzugefügt werden',
  'fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription': 'Fasst die Inhalte des Updates zusammen',
  'fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit': 'Generieren',
  'fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel': 'Atlassian Intelligence fragen',
  'fabric.editor.ai.config.item.action.edit': 'Bearbeiten',
  'fabric.editor.ai.config.item.action.insert': 'Einfügen',
  'fabric.editor.ai.config.item.action.insertAtTop': 'Oben einfügen',
  'fabric.editor.ai.config.item.action.insertBelow': 'Unten einfügen',
  'fabric.editor.ai.config.item.action.insertBelowOriginal': 'Unter dem Original einfügen',
  'fabric.editor.ai.config.item.action.replace': 'Ersetzen',
  'fabric.editor.ai.config.item.action.replaceTitle': 'Titel ersetzen',
  'fabric.editor.ai.config.item.action.replaceTitleTooLongDisabledTooltip':
    'Der Titel darf nicht mehr als {maxLength} Zeichen enthalten.',
  'fabric.editor.ai.config.item.action.rovoAgents.contineChatLabel': 'Im Chat fortfahren',
  'fabric.editor.ai.config.item.action.rovoAgents.continueInChatLabel': 'Im Chat öffnen',
  'fabric.editor.ai.config.item.addPolish.description': 'Optimiert den Inhalt, um ihn ansprechender zu gestalten.',
  'fabric.editor.ai.config.item.addPolish.title': 'Feinschliff hinzufügen',
  'fabric.editor.ai.config.item.agent.title': 'Rovo-Agent von Atlassian Intelligence',
  'fabric.editor.ai.config.item.atlas-shorten-update.description': 'Kürzt den Inhalt, um ihn präziser zu machen',
  'fabric.editor.ai.config.item.atlas-shorten-update.title': 'Update verkürzen',
  'fabric.editor.ai.config.item.bb.pr.description.description':
    'Erstellt eine Beschreibung der Pull-Anfrage mit einer Zusammenfassung der Änderungen',
  'fabric.editor.ai.config.item.bb.pr.description.title': 'Beschreibung für Pull-Anfrage erstellen',
  'fabric.editor.ai.config.item.brainstorm.description':
    'Generiert eine Liste von Ideen für einen Themenbereich, den Sie bereitstellen',
  'fabric.editor.ai.config.item.brainstorm.promptHint': 'Themenbereich eingeben …',
  'fabric.editor.ai.config.item.brainstorm.promptLabel': 'Brainstorming durchführen',
  'fabric.editor.ai.config.item.brainstorm.title': 'Brainstorming durchführen',
  'fabric.editor.ai.config.item.changeTone.adjustLengthNestingParentShortTitle': 'Länge',
  'fabric.editor.ai.config.item.changeTone.adjustLengthNestingParentTitle': 'Länge anpassen',
  'fabric.editor.ai.config.item.changeTone.casualTone.description': 'Ändert den Ton des Inhalts zu "locker"',
  'fabric.editor.ai.config.item.changeTone.casualTone.selectionToolbar.dropdownItem.title': 'Locker',
  'fabric.editor.ai.config.item.changeTone.casualTone.shortTitle': 'Locker',
  'fabric.editor.ai.config.item.changeTone.casualTone.title': 'Zu lockerem Ton wechseln',
  'fabric.editor.ai.config.item.changeTone.educationalTone.description': 'Ändert den Ton des Inhalts zu "informativ"',
  'fabric.editor.ai.config.item.changeTone.educationalTone.selectionToolbar.dropdownItem.title': 'Informativ',
  'fabric.editor.ai.config.item.changeTone.educationalTone.shortTitle': 'Informativ',
  'fabric.editor.ai.config.item.changeTone.educationalTone.title': 'Zu informativem Ton wechseln',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.description': 'Ändert den Ton des Inhalts zu "empathisch"',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.selectionToolbar.dropdownItem.title': 'Empathisch',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.shortTitle': 'Empathisch',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.title': 'Zu empathischem Ton wechseln',
  'fabric.editor.ai.config.item.changeTone.nestingParentTitlePostGA': 'Ton ändern zu …',
  'fabric.editor.ai.config.item.changeTone.neutralTone.description': 'Ändert den Ton des Inhalts zu "neutral"',
  'fabric.editor.ai.config.item.changeTone.neutralTone.selectionToolbar.dropdownItem.title': 'Neutral',
  'fabric.editor.ai.config.item.changeTone.neutralTone.shortTitle': 'Neutral',
  'fabric.editor.ai.config.item.changeTone.neutralTone.title': 'Zu neutralem Ton wechseln',
  'fabric.editor.ai.config.item.changeTone.professionalTone.description':
    'Ändert den Ton des Inhalts zu "professionell"',
  'fabric.editor.ai.config.item.changeTone.professionalTone.selectionToolbar.dropdownItem.title': 'Professionell',
  'fabric.editor.ai.config.item.changeTone.professionalTone.shortTitle': 'Professionell',
  'fabric.editor.ai.config.item.changeTone.professionalTone.title': 'Zu professionellem Ton wechseln',
  'fabric.editor.ai.config.item.convertToBulletList.description':
    'Formatiert Inhalt in eine Liste mit Aufzählungszeichen um',
  'fabric.editor.ai.config.item.convertToBulletList.title': 'In Liste mit Aufzählungszeichen umwandeln',
  'fabric.editor.ai.config.item.convertToTable.description':
    'Formatiert den Inhalt in eine Tabelle mit Überschriften um',
  'fabric.editor.ai.config.item.convertToTable.title': 'In Tabelle umwandeln',
  'fabric.editor.ai.config.item.draftReply.description':
    'Verfasst eine Antwort, die auf ähnlichen Vorgängen basiert wie dem, an dem Sie gerade arbeiten.',
  'fabric.editor.ai.config.item.draftReply.title': 'Antwort verfassen',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.description': 'Behebt Rechtschreib- und Grammatikfehler',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.selectionToolbar.dropdownItem.title':
    'Rechtschreibung und Grammatik',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.title': 'Rechtschreibung und Grammatik korrigieren',
  'fabric.editor.ai.config.item.enhance.improveWriting.description':
    'Verbessert Klarheit, Struktur und Ton für mehr Teilhabe und Verständnis.',
  'fabric.editor.ai.config.item.enhance.improveWriting.selectionToolbar.dropdownItem.title':
    'Texterstellung optimieren',
  'fabric.editor.ai.config.item.enhance.improveWriting.title': 'Texterstellung optimieren',
  'fabric.editor.ai.config.item.findActionItems.description':
    'Sucht Aufgaben in den von Ihnen bereitgestellten Inhalten',
  'fabric.editor.ai.config.item.findActionItems.title': 'Aufgaben suchen',
  'fabric.editor.ai.config.item.freeGenerate.disabled.promptHint':
    'Unten auswählen (aktuell ist die kostenlose Erstellung von Prompts in Elevate deaktiviert)',
  'fabric.editor.ai.config.item.generateContent.promptHint': 'Mit AI schreiben oder von unten auswählen',
  'fabric.editor.ai.config.item.generateEscalationNotes.description':
    'Generiert Eskalationsnotizen basierend auf dem Kontext des Problems.',
  'fabric.editor.ai.config.item.generateEscalationNotes.title': 'Eskalationsnotizen generieren',
  'fabric.editor.ai.config.item.improveDescription.default.description':
    'Strukturiert die Vorgangsbeschreibung anhand des Vorgangstyps neu',
  'fabric.editor.ai.config.item.improveDescription.default.title.experiment.one': 'Beschreibung verbessern',
  'fabric.editor.ai.config.item.makeLonger.description':
    'Erweitert den Inhalt basierend auf dem von Ihnen angegebenen Kontext',
  'fabric.editor.ai.config.item.makeLonger.title': 'Erweitern',
  'fabric.editor.ai.config.item.range.agent.description': 'Keine Beschreibung',
  'fabric.editor.ai.config.item.range.agent.prompt.hint':
    'Bitten Sie den Agenten, etwas zu schreiben, oder wählen Sie unten eine Option aus.',
  'fabric.editor.ai.config.item.rephrase.description': 'Erstellt einen Vorschlag zum Umformulieren Ihrer Sätze',
  'fabric.editor.ai.config.item.rephrase.title': 'Umformulieren',
  'fabric.editor.ai.config.item.shorten.description': 'Kürzt den Inhalt, um ihn präziser zu machen',
  'fabric.editor.ai.config.item.shorten.selectionToolbar.dropdownItem.title': 'Verkürzen',
  'fabric.editor.ai.config.item.shorten.title': 'Verkürzen',
  'fabric.editor.ai.config.item.suggest.description': 'Schlägt einen Titel für von Ihnen bereitgestellte Inhalte vor',
  'fabric.editor.ai.config.item.suggest.title': 'Einen Titel vorschlagen',
  'fabric.editor.ai.config.item.summarize.description':
    'Erstellt eine Zusammenfassung des Textes, an dem Sie arbeiten, und hebt die wichtigsten Punkte hervor',
  'fabric.editor.ai.config.item.summarize.dropdownItem.title': 'Schriftstück zusammenfassen',
  'fabric.editor.ai.config.item.summarize.title': 'Schriftstück zusammenfassen',
  'fabric.editor.ai.config.item.translate.czech': 'Tschechisch',
  'fabric.editor.ai.config.item.translate.danish': 'Dänisch',
  'fabric.editor.ai.config.item.translate.dutch': 'Holländisch',
  'fabric.editor.ai.config.item.translate.english': 'Englisch',
  'fabric.editor.ai.config.item.translate.finnish': 'Finnisch',
  'fabric.editor.ai.config.item.translate.french': 'Französisch',
  'fabric.editor.ai.config.item.translate.german': 'Deutsch',
  'fabric.editor.ai.config.item.translate.hungarian': 'Ungarisch',
  'fabric.editor.ai.config.item.translate.italian': 'Italienisch',
  'fabric.editor.ai.config.item.translate.japanese': 'Japanisch',
  'fabric.editor.ai.config.item.translate.nestingParentTitle.ga': 'Übersetzen',
  'fabric.editor.ai.config.item.translate.nestingParentTitlePostGA': 'Übersetzen in folgende Sprache:',
  'fabric.editor.ai.config.item.translate.norwegian': 'Norwegisch',
  'fabric.editor.ai.config.item.translate.russian': 'Russisch',
  'fabric.editor.ai.config.item.translate.spanish': 'Spanisch',
  'fabric.editor.ai.config.item.translate.swedish': 'Schwedisch',
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.description':
    'Übersetzt den Text, an dem Sie gerade arbeiten, ins Chinesische (Vereinfacht)',
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.title': 'Ins Chinesische (Vereinfacht) übersetzen',
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.description':
    'Übersetzt den Text, an dem Sie gerade arbeiten, ins Chinesische (Traditionell)',
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.title': 'Ins Chinesische (Traditionell) übersetzen',
  'fabric.editor.ai.config.item.translateTo.czech.description':
    'Übersetzt den Text, an dem Sie gerade arbeiten, ins Tschechische',
  'fabric.editor.ai.config.item.translateTo.czech.title': 'Ins Tschechische übersetzen',
  'fabric.editor.ai.config.item.translateTo.danish.description':
    'Übersetzt den Text, an dem Sie gerade arbeiten, ins Dänische',
  'fabric.editor.ai.config.item.translateTo.danish.title': 'Ins Dänische übersetzen',
  'fabric.editor.ai.config.item.translateTo.dutch.description':
    'Übersetzt den Text, an dem Sie gerade arbeiten, ins Niederländische',
  'fabric.editor.ai.config.item.translateTo.dutch.title': 'Ins Niederländische übersetzen',
  'fabric.editor.ai.config.item.translateTo.english.description':
    'Übersetzt den Text, an dem Sie gerade arbeiten, ins Englische',
  'fabric.editor.ai.config.item.translateTo.english.title': 'Ins Englische übersetzen',
  'fabric.editor.ai.config.item.translateTo.finnish.description':
    'Übersetzt den Text, an dem Sie gerade arbeiten, ins Finnische',
  'fabric.editor.ai.config.item.translateTo.finnish.title': 'Ins Finnische übersetzen',
  'fabric.editor.ai.config.item.translateTo.french.description':
    'Übersetzt den Text, an dem Sie gerade arbeiten, ins Französische',
  'fabric.editor.ai.config.item.translateTo.french.title': 'Ins Französische übersetzen',
  'fabric.editor.ai.config.item.translateTo.german.description':
    'Übersetzt den Text, an dem Sie gerade arbeiten, ins Deutsche',
  'fabric.editor.ai.config.item.translateTo.german.title': 'Ins Deutsche übersetzen',
  'fabric.editor.ai.config.item.translateTo.hungarian.description':
    'Übersetzt den Text, an dem Sie gerade arbeiten, ins Ungarische',
  'fabric.editor.ai.config.item.translateTo.hungarian.title': 'Ins Ungarische übersetzen',
  'fabric.editor.ai.config.item.translateTo.italian.description':
    'Übersetzt den Text, an dem Sie gerade arbeiten, ins Italienische',
  'fabric.editor.ai.config.item.translateTo.italian.title': 'Ins Italienische übersetzen',
  'fabric.editor.ai.config.item.translateTo.japanese.description':
    'Übersetzt den Text, an dem Sie gerade arbeiten, ins Japanische',
  'fabric.editor.ai.config.item.translateTo.japanese.title': 'Ins Japanische übersetzen',
  'fabric.editor.ai.config.item.translateTo.korean.description':
    'Übersetzt den Text, an dem Sie gerade arbeiten, ins Koreanische',
  'fabric.editor.ai.config.item.translateTo.korean.title': 'Ins Koreanische übersetzen',
  'fabric.editor.ai.config.item.translateTo.norwegian.description':
    'Übersetzt den Text, an dem Sie gerade arbeiten, ins Norwegische',
  'fabric.editor.ai.config.item.translateTo.norwegian.title': 'Ins Norwegische übersetzen',
  'fabric.editor.ai.config.item.translateTo.polish.description':
    'Übersetzt den Text, an dem Sie gerade arbeiten, ins Polnische',
  'fabric.editor.ai.config.item.translateTo.polish.title': 'Ins Polnische übersetzen',
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.description':
    'Übersetzt den Text, an dem Sie gerade arbeiten, ins Portugiesische (Brasilianisch)',
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.title': 'Ins Portugiesische (Brasilianisch) übersetzen',
  'fabric.editor.ai.config.item.translateTo.russian.description':
    'Übersetzt den Text, an dem Sie gerade arbeiten, ins Russische',
  'fabric.editor.ai.config.item.translateTo.russian.title': 'Ins Russische übersetzen',
  'fabric.editor.ai.config.item.translateTo.spanish.description':
    'Übersetzt den Text, an dem Sie gerade arbeiten, ins Spanische',
  'fabric.editor.ai.config.item.translateTo.spanish.title': 'Ins Spanische übersetzen',
  'fabric.editor.ai.config.item.translateTo.swedish.description':
    'Übersetzt den Text, an dem Sie gerade arbeiten, ins Schwedische',
  'fabric.editor.ai.config.item.translateTo.swedish.title': 'Ins Schwedische übersetzen',
  'fabric.editor.ai.config.item.translateTo.thai.description':
    'Übersetzt den Text, an dem Sie gerade arbeiten, ins Thailändische',
  'fabric.editor.ai.config.item.translateTo.thai.title': 'Ins Thailändische übersetzen',
  'fabric.editor.ai.config.item.translateTo.turkish.description':
    'Übersetzt den Text, an dem Sie gerade arbeiten, ins Türkische',
  'fabric.editor.ai.config.item.translateTo.turkish.title': 'Ins Türkische übersetzen',
  'fabric.editor.ai.config.item.translateTo.ukrainian.description':
    'Übersetzt den Text, an dem Sie gerade arbeiten, ins Ukrainische',
  'fabric.editor.ai.config.item.translateTo.ukrainian.title': 'Ins Ukrainische übersetzen',
  'fabric.editor.ai.config.item.translateTo.vietnamese.description':
    'Übersetzt den Text, an dem Sie gerade arbeiten, ins Vietnamesische',
  'fabric.editor.ai.config.item.translateTo.vietnamese.title': 'Ins Vietnamesische übersetzen',
  'fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle': 'Ton ändern',
  'fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle': 'Umformulieren',
  'fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle': 'Übersetzen',
  'fabric.editor.ai.eventHub.fallbackSuggestedTitle': 'Seitentitel',
  'fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix': 'Seite',
  'fabric.editor.ai.experience-application.cmdPaletteUnhandledErrorMessage':
    'Ein Problem ist aufgetreten und Ihre Antwort kann derzeit nicht generiert werden. Versuchen Sie es später noch einmal.',
  'fabric.editor.ai.experience-application.documentInsertError':
    'Beim Einfügen der Antwort ist ein Problem aufgetreten. Schließen Sie das Dialogfeld und versuchen Sie es dann erneut.',
  'fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage':
    'Beim Erstellen der Vorschau ist ein Problem aufgetreten. Schließen Sie das Dialogfeld und versuchen Sie es dann erneut.',
  'fabric.editor.ai.experience-application.rateLimitEnforced':
    'Wir haben kürzlich zu viele Anfragen für Atlassian Intelligence (AI) erhalten. Versuchen Sie es in ein paar Minuten erneut oder erfahren Sie mehr über die <link>übermäßige Nutzung von AI</link>.',
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    'Es konnte keine Antwort abgerufen werden. Ihre Aufforderung oder Antwort hat das Limit für diese Anfrage überschritten. Schließen Sie das Dialogfeld und versuchen Sie es dann erneut.',
  'fabric.editor.ai.experience-application.unhandledErrorMessage':
    'Es ist ein Problem aufgetreten. Schließen Sie das Dialogfeld und versuchen Sie es dann erneut.',
  'fabric.editor.ai.experience.adfStreamingError': 'Es konnte leider keine Antwort abgerufen werden.',
  'fabric.editor.ai.experience.apiError': 'Wir haben keine Antwort erhalten. Bitte versuchen Sie es erneut.',
  'fabric.editor.ai.experience.aupViolationMessage':
    'Ihr Prompt oder Ihr Inhalt entspricht möglicherweise nicht unseren Richtlinien zur akzeptablen Nutzung. Bitte überprüfen Sie beides und lesen Sie bei Bedarf unsere <link>Richtlinie zur akzeptablen Nutzung</link>. Fall dieses Problem weiterhin besteht, versuchen Sie es mit einem anderen Prompt oder Inhalt.',
  'fabric.editor.ai.experience.browseMore.agents': 'Agenten durchsuchen',
  'fabric.editor.ai.experience.cmdPaletteApiError': 'Beim Generieren Ihrer Antwort ist ein Fehler aufgetreten.',
  'fabric.editor.ai.experience.cmdPaletteAupViolationMessage':
    'Ihre Anfrage konnte nicht bearbeitet werden, da sie nicht unserer <link>Richtlinie zur akzeptablen Nutzung</link> entspricht.',
  'fabric.editor.ai.experience.discardMessagePrompt': 'Möchten Sie Ihre Aufforderung wirklich verwerfen?',
  'fabric.editor.ai.experience.discardMessageResponse': 'Möchten Sie Ihre Antwort wirklich verwerfen?',
  'fabric.editor.ai.experience.discardStreamingInDocumennt': 'Anfrage abbrechen und Antwort verwerfen?',
  'fabric.editor.ai.experience.elevateDisabledGenetateError':
    'Aktuell ist die freie Erstellung von Aufforderungen in Elevate deaktiviert.',
  'fabric.editor.ai.experience.engagementBannerLinksText':
    '🚀 Sie können in Ihren Prompts jetzt Links 🔗 in Jira- oder Confluence-Inhalte einfügen.',
  'fabric.editor.ai.experience.footerRightText.agents': 'Bereitgestellt von Rovo',
  'fabric.editor.ai.experience.generatingAiResponse': 'Wird erstellt',
  'fabric.editor.ai.experience.hipaaContentError':
    'Atlassian Intelligence konnte Ihre Anfrage nicht bearbeiten, da sie Links zu HIPAA-beschränkten Inhalten enthält. Bitte entfernen Sie diese Links und versuchen Sie es erneut.',
  'fabric.editor.ai.experience.inputTooShortError':
    'Der Inhalt ist zu kurz, um ihn zusammenzufassen. Bitte fügen Sie mehr Inhalt hinzu und versuchen Sie es erneut.',
  'fabric.editor.ai.experience.internalServerError':
    'Atlassian Intelligence (AI) reagiert nicht. Versuchen Sie es später erneut oder <link>überprüfen Sie den Status von AI</link>.',
  'fabric.editor.ai.experience.labelRight.atlassianIntelligence': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.labelRight.rovo': 'Rovo',
  'fabric.editor.ai.experience.loadingTitle': 'Wird erstellt',
  'fabric.editor.ai.experience.messageTemplateAnalysingQuery': 'Analyse läuft: Ihre Frage wird überprüft.',
  'fabric.editor.ai.experience.messageTemplateContentSearch':
    'Suche läuft: Warten Sie einen Moment, während wir nach Informationen suchen.',
  'fabric.editor.ai.experience.messageTemplateNextBestTask':
    'Suche läuft: Warten Sie einen Moment, während wir Jira durchsuchen.',
  'fabric.editor.ai.experience.messageTemplatePageHydration':
    'Suche läuft: Warten Sie einen Moment, während wir die Seite durchsuchen.',
  'fabric.editor.ai.experience.noResultsSuggestion': 'Keine Ergebnisse',
  'fabric.editor.ai.experience.responseTooSimilarMessage':
    'Es gibt momentan keine Vorschläge von Atlassian Intelligence. Versuchen Sie es mit einem anderen Prompt oder Inhalt.',
  'fabric.editor.ai.experience.showMoreButton': 'Mehr anzeigen',
  'fabric.editor.ai.experience.suggestionGroupHeading.actions': 'Aktionen',
  'fabric.editor.ai.experience.suggestionGroupHeading.agents': 'Agenten',
  'fabric.editor.ai.experience.suggestionGroupHeading.atlassianIntelligence': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.suggestionGroupHeading.knowledgeSource': 'Wissensquelle',
  'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgents': 'Rovo-Agenten',
  'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgentsCount': 'Rovo-Agenten ({numberOfAgents})',
  'fabric.editor.ai.experience.suggestionGroupHeading.useRovoAgentsCount': 'Rovo-Agenten verwenden ({numberOfAgents})',
  'fabric.editor.ai.experience.useGeneralAiKnowledgeLabel': 'Allgemeines Wissen verwenden',
  'fabric.editor.ai.experience.useRovoOrganisationKnowledgeLabel': 'Wissen aus Ihrer Organisation verwenden',
  'fabric.editor.ai.proactive.error.markdownErrorMessage':
    'Beim Erstellen der Vorschau ist ein Problem aufgetreten. Schließen Sie das Dialogfeld und versuchen Sie es dann erneut.',
  'fabric.editor.ai.proactive.error.unhandledErrorMessage':
    'Ein Problem ist aufgetreten. Schließen Sie das Dialogfeld und versuchen Sie es dann erneut.',
  'fabric.editor.ai.proactive.preview.insertBelowProactiveRecommendation': 'Unten einfügen',
  'fabric.editor.ai.proactive.preview.replaceProactiveRecommendation': 'Ersetzen',
  'fabric.editor.ai.screens.preview.convoAIBeta':
    'Anfragen zur Inhaltserstellung, die auf URLs verweisen, befinden sich in der Beta-Phase.',
  'fabric.editor.ai.selectionToolbar.define.disabled.tooltip':
    'Markieren Sie einen Begriff, ein Akronym oder eine Abkürzung.',
  'fabric.editor.ai.selectionToolbar.define.title': 'Definieren',
  'fabric.editor.ai.telepointer.rovo': 'Rovo',
  'fabric.editor.ai.toolbar.DefineDropdownIconTitle.title': 'Definieren',
  'fabric.editor.ai.toolbar.askAI.title': 'Atlassian Intelligence fragen',
  'fabric.editor.ai.toolbar.askRovo.title': 'Rovo fragen',
  'fabric.editor.ai.toolbar.askRovo.tooltip.quickCommand': "Rovo fragen {key}+'",
  'fabric.editor.ai.toolbar.askRovoAiSplitButton.label': 'Rovo-KI fragen',
  'fabric.editor.ai.toolbar.changeTone.title': 'Ton ändern',
  'fabric.editor.ai.toolbar.changeToneOptions.title': 'Optionen zum Ändern des Tons',
  'fabric.editor.ai.toolbar.improveWriting.title': 'Texterstellung optimieren',
  'fabric.editor.ai.toolbar.improveWriting.tooltip':
    'Weisen Sie Atlassian Intelligence an, den von Ihnen ausgewählten Text zu verbessern.',
  'fabric.editor.ai.toolbar.makeLonger.title': 'Erweitern',
  'fabric.editor.ai.toolbar.makeShorter.title': 'Verkürzen',
  'fabric.editor.ai.toolbar.moreCasualTone.title': 'Lockerer',
  'fabric.editor.ai.toolbar.moreEmpatheticTone.title': 'Empathischer',
  'fabric.editor.ai.toolbar.moreProfessionalTone.title': 'Professioneller',
  'fabric.editor.ai.toolbar.moreRovoOptions.label': 'Weitere Rovo-Optionen',
  'fabric.editor.ai.toolbar.simplifiedAI.title': 'AI',
  'fabric.editor.ai.toolbar.spellingAndGrammar.title': 'Rechtschreibung und Grammatik korrigieren',
  'fabric.editor.ai.toolbar.summarize.title': 'Zusammenfassen',
  'fabric.editor.ai.toolbar.titleText': 'Atlassian Intelligence',
  'fabric.editor.ai.toolbar.translate.title': 'Übersetzen',
  'fabric.editor.ai.toolbar.translateOptions.label': 'Übersetzungsoptionen',
  'fabric.editor.ai.toolbar.tryAI.title': 'AI testen',
  'fabric.editor.ai.toolbar.tryAI.tooltip': 'Atlassian Intelligence öffnen',
  'fabric.editor.ai.toolbar.tryAI.tooltip.quickCommand': "Atlassian Intelligence fragen – {key}+'",
  'fabric.editor.alignCenter': 'Mittig ausrichten',
  'fabric.editor.alignImageCenter': 'Mittig ausrichten',
  'fabric.editor.alignImageLeft': 'Links ausrichten',
  'fabric.editor.alignImageRight': 'Rechts ausrichten',
  'fabric.editor.alignLeft': 'Links ausrichten',
  'fabric.editor.alignRight': 'Rechts ausrichten',
  'fabric.editor.alignTableCenter': 'Mittig ausrichten',
  'fabric.editor.alignTableLeft': 'Links ausrichten',
  'fabric.editor.alignment': 'Textausrichtung',
  'fabric.editor.altText': 'Alternativer Text',
  'fabric.editor.alttext.validation': 'Bitte entfernen Sie jegliche Sonderzeichen in alternativem Text.',
  'fabric.editor.annotationToolbar': 'Symbolleiste für Anmerkungen',
  'fabric.editor.backLink': 'Zurück',
  'fabric.editor.backgroundColor': 'Hintergrundfarbe',
  'fabric.editor.block.menu.codeblock': 'Codeblock',
  'fabric.editor.block.menu.copy.block': 'Block kopieren',
  'fabric.editor.block.menu.copy.link': 'Link kopieren',
  'fabric.editor.block.menu.delete.block': 'Löschen',
  'fabric.editor.block.menu.layout': 'Layout',
  'fabric.editor.block.menu.move.down': 'Nach unten verschieben',
  'fabric.editor.block.menu.move.up': 'Nach oben verschieben',
  'fabric.editor.block.menu.paragraph': 'Absatz',
  'fabric.editor.blockCardUnavailable':
    'Die Ansicht des Inline-Links kann nicht geändert werden, da sich der Link innerhalb von {node} befindet.',
  'fabric.editor.blockControlDelete': 'Löschen',
  'fabric.editor.blockControlDragHandleMove': 'Zum Verschieben ziehen',
  'fabric.editor.blockControlDragHandleRearrange': 'Zum Neuanordnen ziehen',
  'fabric.editor.blockControlInsert': 'Einfügen',
  'fabric.editor.blockControlMoveDown': 'Nach unten verschieben',
  'fabric.editor.blockControlMoveLeft': 'Nach links',
  'fabric.editor.blockControlMoveRight': 'Nach rechts',
  'fabric.editor.blockControlMoveUp': 'Nach oben verschieben',
  'fabric.editor.blockControlMovedDown': 'Inhalt wurde nach unten verschoben',
  'fabric.editor.blockControlMovedUp': 'Inhalt wurde nach oben verschoben',
  'fabric.editor.blockDescription':
    'Weitere Informationen zu einem Link anzeigen, darunter eine Zusammenfassung und Aktionen',
  'fabric.editor.blockTitle': 'Karte',
  'fabric.editor.blockquote': 'ein Angebot',
  'fabric.editor.blockquote.description': 'Zitat einfügen',
  'fabric.editor.blockquote2': 'Zitieren',
  'fabric.editor.bold': 'Fett',
  'fabric.editor.breakout.resizeCodeBlock': 'Größe des Code-Auszugs ändern',
  'fabric.editor.breakout.resizeElement': 'Größe des Elements ändern',
  'fabric.editor.breakout.resizeExpand': 'Größe der Erweiterung ändern',
  'fabric.editor.breakout.resizeLayout': 'Größe des Layouts ändern',
  'fabric.editor.breakoutFullWidthLabel': 'Volle Breite',
  'fabric.editor.breakoutWideWidthLabel': 'Breit',
  'fabric.editor.bug': 'Bug',
  'fabric.editor.bulletedList': 'Liste mit Aufzählungszeichen',
  'fabric.editor.canNotSortTable': '⚠️ Tabellen mit zusammengeführten Zellen können nicht sortiert werden.',
  'fabric.editor.cancelButton': 'Abbrechen',
  'fabric.editor.captionPlaceholder': 'Eine Bildunterschrift hinzufügen',
  'fabric.editor.captionPlaceholderWithDoubleClickPrompt':
    'Fügen Sie eine Bildunterschrift hinzu und führen Sie einen Doppelklick aus, um eine Vorschau davon anzuzeigen.',
  'fabric.editor.cardFloatingControls': 'Kartenoptionen',
  'fabric.editor.cellBackground': 'Zellenhintergrund',
  'fabric.editor.cellOptions': 'Zelloptionen',
  'fabric.editor.checkUncheckActionItem': 'Aufgabe umschalten',
  'fabric.editor.clearAltTextEdit': 'Alternativtext löschen',
  'fabric.editor.clearCells': '{0, plural, one {Zelleninhalt löschen} other {Zelleninhalte löschen}}',
  'fabric.editor.clearFormatting': 'Formatierung löschen',
  'fabric.editor.clearLink': 'Link löschen',
  'fabric.editor.clearLinkText': 'Text löschen',
  'fabric.editor.closeAltTextEdit': 'Zurück',
  'fabric.editor.closeFindReplaceDialog': 'Schließen',
  'fabric.editor.closeHelpDialog': 'Hilfedialog schließen',
  'fabric.editor.code': 'Code',
  'fabric.editor.code.on': '{textFormattingOff}, Code ein',
  'fabric.editor.codeBidiWarningLabel':
    'Bidirektionale Zeichen ändern die Reihenfolge, in der Text gerendert wird. Dies könnte verwendet werden, um bösartigen Code zu verbergen.',
  'fabric.editor.codeBlockCopyButton.copiedToClipboard': 'Kopiert!',
  'fabric.editor.codeBlockCopyButton.copyToClipboard': 'Als Text kopieren',
  'fabric.editor.codeBlockWrapButton.unwrapCodeBlock': 'Zeilenumbrüche deaktivieren',
  'fabric.editor.codeBlockWrapButton.wrapCodeBlock': 'Zeilenumbrüche aktivieren',
  'fabric.editor.codeblock': 'Code-Auszug',
  'fabric.editor.codeblock.description': 'Code mit Syntaxhervorhebungen anzeigen',
  'fabric.editor.collapseNode': 'Inhaltsanzeige reduzieren',
  'fabric.editor.collapseTable': 'Tabelle reduzieren',
  'fabric.editor.colorPicker.menuLabel': 'Menü zur Farbauswahl',
  'fabric.editor.columnDragHandle': 'Spaltenoptionen',
  'fabric.editor.columnMovedLeft': 'Spalte nach links verschoben auf {index} von {total}',
  'fabric.editor.columnMovedRight': 'Spalte nach rechts verschoben auf {index} von {total}',
  'fabric.editor.columnSelected': 'Spalte {index} von {total} ausgewählt',
  'fabric.editor.columns': 'Layouts',
  'fabric.editor.columns.advanced.layout.description':
    '{numberOfColumns, plural, one {{numberOfColumns} gleich große Spalte einfügen} other {{numberOfColumns} gleich große Spalten einfügen}}',
  'fabric.editor.columns.advanced.layout.single.description': 'Layout mit einer Spalte einfügen',
  'fabric.editor.columns.description': 'Seite mithilfe von Abschnitten strukturieren',
  'fabric.editor.columnsAreInserted':
    '{count, plural, one {Eine Spalte wurde hinzugefügt.} other {{count} Spalten wurden hinzugefügt.}}',
  'fabric.editor.columnsAreRemoved':
    '{count, plural, one {Die Spalte wurde entfernt.} other {{count} Spalten wurden entfernt.}}',
  'fabric.editor.configFailedToLoad': 'Fehler beim Laden',
  'fabric.editor.configPanel.cancel': 'Abbrechen',
  'fabric.editor.configPanel.close': 'Schließen',
  'fabric.editor.configPanel.customSelect.createOption': 'Erstellen',
  'fabric.editor.configPanel.dateRange.custom.from': 'Von',
  'fabric.editor.configPanel.dateRange.custom.to': 'Bis',
  'fabric.editor.configPanel.dateRange.grouping.collapse': 'Reduzieren',
  'fabric.editor.configPanel.dateRange.grouping.expand': 'Erweitern',
  'fabric.editor.configPanel.dateRange.option.custom': 'Benutzerdefiniert',
  'fabric.editor.configPanel.documentation': 'Dokumentation',
  'fabric.editor.configPanel.errorBoundary.note':
    'Das Team wurde benachrichtigt. Sie können diese Seite weiterhin bearbeiten und veröffentlichen oder die Fehlerkonsole aufrufen, um weitere Informationen zu erhalten.',
  'fabric.editor.configPanel.errorBoundary.title': 'Irgendetwas ist schiefgelaufen.',
  'fabric.editor.configPanel.fieldTypeError.isMultipleAndRadio':
    'isMultiple kann nicht mit Stil: radio kombiniert werden.',
  'fabric.editor.configPanel.formType.addField': 'Feld hinzufügen',
  'fabric.editor.configPanel.formType.removeField': 'Feld entfernen',
  'fabric.editor.configPanel.help': 'Benötigen Sie Hilfe?',
  'fabric.editor.configPanel.invalid': 'Ungültiges Feld',
  'fabric.editor.configPanel.required': 'Pflichtfeld',
  'fabric.editor.configPanel.submit': 'Senden',
  'fabric.editor.contextPanel.panelLabel': 'Kontext-Panel',
  'fabric.editor.copiedToClipboard': 'Kopiert!',
  'fabric.editor.copyToClipboard': 'Kopieren',
  'fabric.editor.cornerControl': 'Tabelle hervorheben',
  'fabric.editor.createComment': 'Kommentieren',
  'fabric.editor.createCommentDisabled':
    'Sie können nur Text, Überschriften, Emojis, Daten, Erwähnungen, Links und Status kommentieren.',
  'fabric.editor.createCommentInvalid': 'Sie können nur Kommentare für Text und Überschriften hinterlassen.',
  'fabric.editor.customPanel': 'Benutzerdefiniertes Panel',
  'fabric.editor.customPanel.description': 'Fügen Sie einen Hinweis mit Emoji und farbigem Hintergrund hinzu',
  'fabric.editor.datasource.assetsObjects.description':
    'Fügen Sie Objekte aus Assets in Jira Service Management mit Such- und Filterfunktionen ein.',
  'fabric.editor.datasource.assetsObjectsGeneralAvailability': 'Assets',
  'fabric.editor.datasource.confluenceSearch': 'Confluence-Liste einfügen',
  'fabric.editor.datasource.confluenceSearch.description':
    'Fügen Sie eine Liste der Suchergebnisse von Confluence mit verbesserter Suche, Filterung und Konfiguration ein.',
  'fabric.editor.datasource.jiraIssue': 'Jira-Vorgänge',
  'fabric.editor.datasource.jiraIssue.description':
    'Fügen Sie Jira-Vorgänge aus Jira Cloud mit verbesserten Such-, Filter- und Konfigurationsfunktionen ein.',
  'fabric.editor.datasource.jiraIssue.description.issue-term-refresh':
    'Fügen Sie Jira-Vorgänge aus Jira Cloud mit verbesserten Such-, Filter- und Konfigurationsfunktionen ein.',
  'fabric.editor.datasource.jiraIssue.issue-term-refresh': 'Jira-Vorgänge',
  'fabric.editor.datasourceAppearanceTitle': 'Liste',
  'fabric.editor.datasourceTitle': 'Suchanfrage bearbeiten',
  'fabric.editor.date': 'Datum',
  'fabric.editor.date.description': 'Datum mittels Kalender hinzufügen',
  'fabric.editor.datePickerOpenedAlert':
    'Pop-up des Datumseditors wurde geöffnet. Drücken Sie die Tabulatortaste, um das Pop-up aufzurufen.',
  'fabric.editor.decision': 'Entscheidung',
  'fabric.editor.decision.description': 'Entscheidungen erfassen, um sie leicht zu verfolgen',
  'fabric.editor.decisionPlaceholder': 'Entscheidung hinzufügen …',
  'fabric.editor.decreaseElementSize': 'Größe des Elements verringern',
  'fabric.editor.decreaseSize': 'Tabellen- oder Mediengröße verringern',
  'fabric.editor.defaultAltText': 'Dokument',
  'fabric.editor.delete': 'Löschen',
  'fabric.editor.description': 'Beschreibung',
  'fabric.editor.displayBlock': 'Karte anzeigen',
  'fabric.editor.displayEmbed': 'Einbettung anzeigen',
  'fabric.editor.displayInline': 'Inline anzeigen',
  'fabric.editor.displayLink': 'Als Text anzeigen',
  'fabric.editor.displayOptionUnavailableInParentNode': 'Diese Anzeigeoption ist in {node} nicht verfügbar.',
  'fabric.editor.displayText': 'Text zum Anzeigen',
  'fabric.editor.distributeColumns': 'Spalten verteilen',
  'fabric.editor.dragHandleZone': 'Bereich des Ziehpunkts aktivieren',
  'fabric.editor.dropPlaceholderLabel': 'Dokument',
  'fabric.editor.ecombedDescription': 'Interaktive Vorschau eines Links anzeigen',
  'fabric.editor.edit': 'Bearbeiten',
  'fabric.editor.edit.datasource': 'Suchanfrage bearbeiten',
  'fabric.editor.edit.searchInput': 'Einen Link hinzufügen',
  'fabric.editor.editAccessTitle': 'Sie benötigen Bearbeitungszugriff',
  'fabric.editor.editAltText': 'Alternativtext bearbeiten',
  'fabric.editor.editDatasourceStandalone': 'Bearbeiten',
  'fabric.editor.editDatasourceStandaloneTooltip': 'Suchanfrage bearbeiten',
  'fabric.editor.editDateText': 'Datum bearbeiten',
  'fabric.editor.editDropdownEditDatasourceTitle': 'Suchanfrage bearbeiten',
  'fabric.editor.editDropdownEditLinkTitle': 'Link bearbeiten',
  'fabric.editor.editDropdownExpandIconLabel': 'Drop-down-Menü erweitern',
  'fabric.editor.editDropdownTriggerTitle': 'Bearbeiten',
  'fabric.editor.editLink': 'Link bearbeiten',
  'fabric.editor.editMode.inviteToEditButton.title': 'Zum Bearbeiten einladen',
  'fabric.editor.editStatusColor': 'Statusfarbe bearbeiten',
  'fabric.editor.editStatusText': 'Status bearbeiten',
  'fabric.editor.editableContentLabel': 'Editierbarer Inhalt',
  'fabric.editor.editorHelp': 'Editorhilfe',
  'fabric.editor.editors': 'Editoren',
  'fabric.editor.elementBrowser.help': 'Hilfe',
  'fabric.editor.elementInsertSidePanel.title': 'Einfügen',
  'fabric.editor.elementbrowser.categorylist.category-admin': 'Administration',
  'fabric.editor.elementbrowser.categorylist.category-ai': 'Atlassian Intelligence',
  'fabric.editor.elementbrowser.categorylist.category-all': 'Alle',
  'fabric.editor.elementbrowser.categorylist.category-communication': 'Kommunikation',
  'fabric.editor.elementbrowser.categorylist.category-confluence-content': 'Confluence-Inhalt',
  'fabric.editor.elementbrowser.categorylist.category-development': 'Entwicklung',
  'fabric.editor.elementbrowser.categorylist.category-external-content': 'Externer Inhalt',
  'fabric.editor.elementbrowser.categorylist.category-formatting': 'Formatierung',
  'fabric.editor.elementbrowser.categorylist.category-media': 'Medien',
  'fabric.editor.elementbrowser.categorylist.category-navigation': 'Navigation',
  'fabric.editor.elementbrowser.categorylist.category-reporting': 'Berichterstellung',
  'fabric.editor.elementbrowser.categorylist.category-visuals': 'Steuerelemente und Bilder',
  'fabric.editor.elementbrowser.featured.whiteboard.description':
    'Verwenden Sie ein Whiteboard, um Ihrer Seite Grafiken hinzuzufügen.',
  'fabric.editor.elementbrowser.search.empty-state.heading': 'Keine Treffer für Ihre Suchanfrage',
  'fabric.editor.elementbrowser.search.empty-state.sub-heading':
    'Versuchen Sie, nach einem anderen Begriff zu suchen, oder entdecken Sie neue Apps für Atlassian-Produkte.',
  'fabric.editor.elementbrowser.search.empty-state.sub-heading.link': 'Atlassian Marketplace erkunden',
  'fabric.editor.elementbrowser.searchbar.assistive.text.default':
    '{count, plural, =0 {Keine Treffer für Ihre Suchanfrage.} one {Standardmäßig {count} Vorschlag verfügbar.} other {Standardmäßig {count} Vorschläge verfügbar.}}',
  'fabric.editor.elementbrowser.searchbar.assistive.text.result':
    '{count, plural, =0 {Keine Treffer für Ihre Suchanfrage.} one {{count} Vorschlag für eingegebenen Text verfügbar.} other {{count} Vorschläge für eingegebenen Text verfügbar.}}',
  'fabric.editor.elementbrowser.searchbar.elementAfterInput': 'Eingeben',
  'fabric.editor.elementbrowser.searchbar.placeholder': 'Suchen',
  'fabric.editor.elementbrowser.sidebar.heading': 'Durchsuchen',
  'fabric.editor.embedTitle': 'Einbetten',
  'fabric.editor.embedToBlockCardWarning': 'Wird auf kleinen Bildschirmen als Karte angezeigt',
  'fabric.editor.emoji': 'Emoji',
  'fabric.editor.emoji.description': 'Verwenden Sie Emojis, um Ideen 🎉 und Emotionen 😄 auszudrücken.',
  'fabric.editor.emptyLink': 'Bitte geben Sie einen Link ein.',
  'fabric.editor.emptySearchResults': 'Es wurden keine Ergebnisse gefunden.',
  'fabric.editor.emptySearchResultsSuggestion': 'Wählen Sie {buttonName} aus, um Einfügungen zu durchsuchen.',
  'fabric.editor.epic': 'Epic',
  'fabric.editor.error': 'Fehler',
  'fabric.editor.errorPanel': 'Fehler-Panel',
  'fabric.editor.errorPanel.description': 'Fehler in einem farbigen Panel hervorheben',
  'fabric.editor.expand': 'Erweiterung',
  'fabric.editor.expand.description': 'Eine Erweiterung einfügen',
  'fabric.editor.expandAriaLabel': 'Wählen Sie einen Titel für diese Erweiterung',
  'fabric.editor.expandDefaultTitle': 'Klicken Sie hier, um zu erweitern …',
  'fabric.editor.expandNode': 'Inhaltsanzeige erweitern',
  'fabric.editor.expandPlaceholder': 'Wählen Sie einen Titel für diese Erweiterung …',
  'fabric.editor.extension.confirmDeleteLinkedModalMessage':
    'Durch das Löschen von {nodeName} werden alle damit verbundenen Elemente unbrauchbar.',
  'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix': 'Wird gelöscht',
  'fabric.editor.extension.confirmDeleteLinkedModalOKButton': 'Löschen',
  'fabric.editor.extension.deleteElementTitle': 'Element löschen',
  'fabric.editor.extension.sourceNoTitledName': 'dieses Element',
  'fabric.editor.extensions.config-panel.save-indicator': 'Alle Änderungen werden immer automatisch gespeichert.',
  'fabric.editor.externalExtensionsHeading': 'Apps',
  'fabric.editor.externalMediaFile': 'Externe Mediendatei',
  'fabric.editor.failed_to_upload': 'Upload fehlgeschlagen',
  'fabric.editor.feedbackDialog': 'Feedback geben',
  'fabric.editor.feedbackDialog.description': 'Teilen Sie uns Ihre Erfahrungen mit dem Cloud-Editor mit.',
  'fabric.editor.find': 'Suchen',
  'fabric.editor.findNext': 'Nächstes suchen',
  'fabric.editor.findPrevious': 'Vorheriges suchen',
  'fabric.editor.findReplaceToolbarButton': 'Suchen und ersetzen',
  'fabric.editor.fiveColumns': 'Layout mit 5 Spalten',
  'fabric.editor.floatingToolbar.confirmModalCancel': 'Abbrechen',
  'fabric.editor.floatingToolbar.confirmModalCheckboxLabel': 'Verbundene Elemente ebenfalls löschen',
  'fabric.editor.floatingToolbar.confirmModalConnectedUnit':
    '{amount, plural, =0 {{name}} one {{name} (+1 verbundenes Element)} other {{name} (+{amount,number} verbundene Elemente)}}',
  'fabric.editor.floatingToolbar.confirmModalHeading': 'Sind Sie sicher?',
  'fabric.editor.floatingToolbar.confirmModalOK': 'OK',
  'fabric.editor.floatingToolbar.floatingToolbarAnnouncer':
    'Steuerelemente für nicht verankerte Symbolleiste wurden geöffnet',
  'fabric.editor.floatingToolbar.floatingToolbarAriaLabel': 'Nicht verankerte Symbolleiste',
  'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel': 'Layout-Optionen',
  'fabric.editor.floatingToolbar.scrollLeft': 'Nach links scrollen',
  'fabric.editor.floatingToolbar.scrollRight': 'Nach rechts scrollen',
  'fabric.editor.focusTableResizeHandle': 'Ziehpunkt zur Größenänderung der Tabelle fokussieren',
  'fabric.editor.fourColumns': 'Layout mit 4 Spalten',
  'fabric.editor.headerColumn': 'Kopfzeilen-Spalte',
  'fabric.editor.headerRow': 'Kopfzeile',
  'fabric.editor.heading1': 'Überschrift 1',
  'fabric.editor.heading1Description': 'Verwenden Sie dies für Überschriften oberster Ebene.',
  'fabric.editor.heading2': 'Überschrift 2',
  'fabric.editor.heading2Description': 'Verwenden Sie dies für Schlüsselbereiche.',
  'fabric.editor.heading3': 'Überschrift 3',
  'fabric.editor.heading3Description': 'Verwenden Sie dies für Unterbereiche und Gruppenüberschriften.',
  'fabric.editor.heading4': 'Überschrift 4',
  'fabric.editor.heading4Description': 'Verwenden Sie dies für Überschriften tieferer Ebene.',
  'fabric.editor.heading5': 'Überschrift 5',
  'fabric.editor.heading5Description': 'Verwenden Sie dies für die Gruppierung von Listenelementen.',
  'fabric.editor.heading6': 'Überschrift 6',
  'fabric.editor.heading6Description': 'Verwenden Sie dies für Überschriften niedrigerer Ebene.',
  'fabric.editor.headingLink.ascOrderLabel': 'Spalte von Z nach A sortieren',
  'fabric.editor.headingLink.descOrderLabel': 'Sortierung löschen',
  'fabric.editor.headingLink.hyperlinkIconBlogLabel': 'Blog',
  'fabric.editor.headingLink.hyperlinkIconBugLabel': 'Bug',
  'fabric.editor.headingLink.hyperlinkIconIssueLabel': 'Vorgang',
  'fabric.editor.headingLink.hyperlinkIconIssueLabel.issue-term-refresh': 'Vorgang',
  'fabric.editor.headingLink.hyperlinkIconPageLabel': 'Seite',
  'fabric.editor.headingLink.hyperlinkIconStoryLabel': 'Story',
  'fabric.editor.headingLink.hyperlinkIconTaskLabel': 'Task',
  'fabric.editor.headingLink.invalidLabel': '⚠️ Tabellen mit zusammengeführten Zellen können nicht sortiert werden.',
  'fabric.editor.headingLink.noOrderLabel': 'Spalte von A nach Z sortieren',
  'fabric.editor.help': 'Hilfe',
  'fabric.editor.help.description': 'Alle Tastenkombinationen und Markdown-Optionen durchsuchen',
  'fabric.editor.helpDialogTips': 'Drücken Sie {keyMap}, um diesen Dialog jederzeit schnell zu öffnen',
  'fabric.editor.highlight': 'Markierungsfarbe',
  'fabric.editor.highlight.removeColor': 'Farbe entfernen',
  'fabric.editor.highlightColor': 'Farbpalette für Hervorhebungen umschalten',
  'fabric.editor.highlightFloatingToolbar': 'Hervorheben',
  'fabric.editor.horizontalRule': 'Trennlinie',
  'fabric.editor.horizontalRule.description': 'Inhalte mithilfe einer horizontalen Linie unterteilen',
  'fabric.editor.hyperlink.linkVisibleLabel': 'Link einfügen oder suchen',
  'fabric.editor.hyperlink.searchLinkAriaDescription': 'Während Ihrer Eingabe in das Feld werden Vorschläge angezeigt',
  'fabric.editor.hyperlink.searchLinkResults':
    '{count, plural, =0 {Keine Ergebnisse gefunden} one {{count,number} Ergebnis gefunden} other {{count,number} Ergebnisse gefunden}}',
  'fabric.editor.hyperlink.textVisibleLabel': 'Anzeigetext (optional)',
  'fabric.editor.hyperlinkToolbarPlaceholder': 'Link einfügen oder suchen',
  'fabric.editor.image': 'Bild',
  'fabric.editor.image.fullWidthLabel': 'Volle Breite',
  'fabric.editor.imageBorderBold': 'Breit',
  'fabric.editor.imageBorderColor': 'Farbe',
  'fabric.editor.imageBorderColor.dropdownAriaLabel': 'Drop-down-Menü für die Farbauswahl von Bildrändern',
  'fabric.editor.imageBorderMedium': 'Mittel',
  'fabric.editor.imageBorderOptions': 'Rahmenoptionen',
  'fabric.editor.imageBorderSize': 'Größe',
  'fabric.editor.imageBorderSize.dropdownAriaLabel': 'Drop-down-Menü für die Größenauswahl von Bildrändern',
  'fabric.editor.imageBorderSubtle': 'Schmal',
  'fabric.editor.improvement': 'Verbesserung',
  'fabric.editor.increaseElementSize': 'Größe des Elements erhöhen',
  'fabric.editor.increaseSize': 'Tabellen- oder Mediengröße erhöhen',
  'fabric.editor.indent': 'Einzug vergrößern',
  'fabric.editor.info': 'Info',
  'fabric.editor.infoPanel': 'Info-Panel',
  'fabric.editor.infoPanel.description': 'Informationen in einem farbigen Panel hervorheben',
  'fabric.editor.inlineConfigureLink': 'Link konfigurieren',
  'fabric.editor.inlineDescription': 'Link als Inline-Text anzeigen',
  'fabric.editor.inlineGoToLink': 'Verknüpfung aufrufen',
  'fabric.editor.inlineOverlay': 'Konfigurieren',
  'fabric.editor.inlineTitle': 'Inline',
  'fabric.editor.inputQueryAssistiveTxt':
    'Wenn Autovervollständigungen angezeigt werden, navigieren Sie mit den Pfeiltasten nach oben und unten und drücken Sie die Eingabetaste zur Auswahl eines Ergebnisses. Benutzer mit Touchscreen-Geräten können mit Berührungen und Wischgesten navigieren.',
  'fabric.editor.insertColumn': 'Spalte rechts einfügen',
  'fabric.editor.insertColumnDrag': 'Spalte einfügen',
  'fabric.editor.insertMenu': 'Elemente einfügen',
  'fabric.editor.insertRightRail.close': 'Schließen',
  'fabric.editor.insertRightRail.title': 'Einfügen',
  'fabric.editor.insertRow': 'Zeile unten einfügen',
  'fabric.editor.insertRowDrag': 'Zeile einfügen',
  'fabric.editor.insertTableColumn': 'Tabellenspalte einfügen',
  'fabric.editor.insertTableRow': 'Tabellenzeile einfügen',
  'fabric.editor.invalidDateError': 'Bitte geben Sie ein gültiges Datum ein.',
  'fabric.editor.invalidLink': 'Bitte geben Sie einen gültigen Link ein.',
  'fabric.editor.inviteItem.title':
    '{userRole, select, admin {Teammitglied zu {productName} einladen} trusted {Teammitglied zu {productName} einladen} other {Teammitglied zu {productName} hinzufügen}}',
  'fabric.editor.italic': 'Kursiv',
  'fabric.editor.keyboardShortcuts': 'Tastenkombinationen',
  'fabric.editor.layout.columnOption': '{count, plural, one {Spalte} other {{count} Spalten}}',
  'fabric.editor.layout.controls.placeholder': '/ eingeben, um etwas einzufügen',
  'fabric.editor.layout.placeholder': 'Inhalt hinzufügen',
  'fabric.editor.layout.resizeLayout': 'Größe des Layouts ändern',
  'fabric.editor.layoutFixedWidth': 'Zurück zur Mitte',
  'fabric.editor.layoutFullWidth': 'Volle Breite wählen',
  'fabric.editor.layoutStateFixedWidth': 'Zentriert',
  'fabric.editor.layoutStateFullWidth': 'Maximale Breite',
  'fabric.editor.layoutStateWide': 'Breit',
  'fabric.editor.layoutWide': 'Verbreitern',
  'fabric.editor.leftSidebar': 'Layout der linken Seitenleiste',
  'fabric.editor.link': 'Link',
  'fabric.editor.link.description': 'Link einfügen',
  'fabric.editor.linkAddress': 'Link-Adresse',
  'fabric.editor.linkPlaceholder': 'Link einfügen',
  'fabric.editor.lists': 'Listen',
  'fabric.editor.listsFormat': 'Formatierung der Liste',
  'fabric.editor.lockColumns': 'Feste Spaltenbreiten',
  'fabric.editor.longEmptyNodePlaceholderText': 'Geben Sie "/" ein, um Elemente einzufügen.',
  'fabric.editor.markdown': 'Markdown',
  'fabric.editor.matchCase': 'Groß-/Kleinschreibung beachten',
  'fabric.editor.media.DefaultMediaWidthDecreased':
    '{newMediaWidth, plural, one {Die Medienbreite wurde auf {newMediaWidth,number} Pixel verringert.} other {Die Medienbreite wurde auf {newMediaWidth,number} Pixel verringert.}}',
  'fabric.editor.media.DefaultMediaWidthIncreased':
    '{newMediaWidth, plural, one {Die Medienbreite wurde auf {newMediaWidth,number} Pixel erhöht.} other {Die Medienbreite wurde auf {newMediaWidth,number} Pixel erhöht.}}',
  'fabric.editor.media.MediaWidthIsMin': 'Medien auf Mindestgröße verringert',
  'fabric.editor.media.insert.cancel': 'Abbrechen',
  'fabric.editor.media.insert.fileTabTitle': 'Datei',
  'fabric.editor.media.insert.fromUrlErrorMessage':
    'Leider kann dieser Bildlink nicht hinzugefügt werden. Laden Sie das Bild herunter und ziehen Sie es anschließend per Drag-and-Drop auf die Seite.',
  'fabric.editor.media.insert.fromUrlWarning':
    'Dieses Bild ist aufgrund von Quellenbeschränkungen möglicherweise nicht für andere sichtbar. Erwägen Sie stattdessen, die Datei hochzuladen.',
  'fabric.editor.media.insert.insert': 'Einfügen',
  'fabric.editor.media.insert.invalidUrlErrorMessage': 'Ungültiger Link',
  'fabric.editor.media.insert.linkTabTitle': 'Link',
  'fabric.editor.media.insert.loadPreview': 'Vorschau laden',
  'fabric.editor.media.insert.localFileErrorMessage': 'Diese Datei konnte nicht hochgeladen werden.',
  'fabric.editor.media.insert.localFileNetworkErrorMessage':
    'Fehler beim Hochladen der Datei. Überprüfen Sie den Dateipfad oder das Netzwerk.',
  'fabric.editor.media.insert.mediaAlt': 'Vorschau für die hochgeladene Bild- oder Videodatei',
  'fabric.editor.media.insert.mediaPickerPopupAriaLabel': 'Medienauswahl',
  'fabric.editor.media.insert.pasteLinkToUpload': 'Link zum Hochladen einfügen',
  'fabric.editor.media.insert.upload': 'Hochladen',
  'fabric.editor.media.pixelEntry.MediaWidthIsMax': 'Medien auf maximale Größe erhöht',
  'fabric.editor.media.pixelEntry.ResizeOption': 'Größe ändern',
  'fabric.editor.media.pixelEntry.closePixelEntry': 'Schließen',
  'fabric.editor.media.pixelEntry.inputHeightAriaLabel': 'Eingabe der Höhe',
  'fabric.editor.media.pixelEntry.inputHeightTooltip': 'Höhe',
  'fabric.editor.media.pixelEntry.inputWidthAriaLabel': 'Maximale Breite: {maxWidth} px',
  'fabric.editor.media.pixelEntry.inputWidthLabel': 'Breite',
  'fabric.editor.media.pixelEntry.inputWidthTooltip': 'Maximale Breite: {maxWidth} px',
  'fabric.editor.media.pixelEntry.migrationButtonText': 'In Pixel umwandeln',
  'fabric.editor.media.pixelEntry.migrationButtonTooltip': 'Von prozentualer zu fester Pixelgröße migrieren',
  'fabric.editor.media.pixelEntry.submitButtonText': 'Senden',
  'fabric.editor.media.pixelEntry.validationFailedMessage': 'Überprüfung der Breite fehlgeschlagen',
  'fabric.editor.mediaAddLink': 'Link hinzufügen',
  'fabric.editor.mediaFiles': 'Bild, Video oder Datei',
  'fabric.editor.mediaFiles.description': 'Bilder oder andere Dateien zu Ihrer Seite hinzufügen',
  'fabric.editor.mediaGroupDeleteLabel': 'Löschen',
  'fabric.editor.media_change_mediainline_caption_warn': 'Inline (Bildunterschrift wird entfernt)',
  'fabric.editor.media_change_mediainline_default': 'Inline',
  'fabric.editor.media_change_mediasingle': 'Originalgröße',
  'fabric.editor.mention': 'Erwähnen',
  'fabric.editor.mention.description': 'Erwähnen Sie einen Benutzer, um ihm eine Benachrichtigung zu senden.',
  'fabric.editor.mentionNode.label': 'Markierung von Benutzer',
  'fabric.editor.mentionsAddLabel': 'Hinzufügen-Symbol',
  'fabric.editor.mentionsIconLabel': 'Erwähnen',
  'fabric.editor.mergeCells': 'Zellen zusammenführen',
  'fabric.editor.moreFormatting': 'Mehr Formatierungsoptionen',
  'fabric.editor.moveColumnLeft':
    '{0, plural, one {Spalte nach links verschieben} other {Spalten nach links verschieben}}',
  'fabric.editor.moveColumnRight':
    '{0, plural, one {Spalte nach rechts verschieben} other {Spalten nach rechts verschieben}}',
  'fabric.editor.moveDownDown': '{0, plural, one {Zeile nach unten verschieben} other {Zeilen nach unten verschieben}}',
  'fabric.editor.moveRowUp': '{0, plural, one {Zeile nach oben verschieben} other {Zeilen nach oben verschieben}}',
  'fabric.editor.navigate.toolbar.askAI': 'KI fragen',
  'fabric.editor.navigate.toolbar.editor': 'Zur Editor-Symbolleiste navigieren',
  'fabric.editor.navigate.toolbar.floating': 'Zur unverankerten Symbolleiste navigieren',
  'fabric.editor.noPermissionToAddComment':
    '{contentType, select, blogpost {Sie sind nicht berechtigt, diesem Blogpost Kommentare hinzuzufügen.} page {Sie sind nicht berechtigt, dieser Seite Kommentare hinzuzufügen.} other {Sie sind nicht berechtigt, dieser Seite Kommentare hinzuzufügen.}}',
  'fabric.editor.noResultsFound': 'Keine Ergebnisse',
  'fabric.editor.noSearchResults': 'Keine Suchergebnisse',
  'fabric.editor.normal': 'Normaler Text',
  'fabric.editor.note': 'Hinweis',
  'fabric.editor.notePanel': 'Hinweis-Panel',
  'fabric.editor.notePanel.description': 'Hinweis in einem farbigen Panel einfügen',
  'fabric.editor.numberedColumn': 'Nummerierte Spalte',
  'fabric.editor.off': '{formattingType} aus',
  'fabric.editor.on': '{formattingType} ein',
  'fabric.editor.openButtonTitle': 'Öffnen',
  'fabric.editor.openCellOptions': 'Zellenoptionen öffnen',
  'fabric.editor.openLink': 'Link in neuer Registerkarte öffnen',
  'fabric.editor.openPreviewPanel': 'Vorschaupanel öffnen',
  'fabric.editor.orderedList': 'Nummerierte Liste',
  'fabric.editor.orderedList.description': 'Sortierte Liste erstellen',
  'fabric.editor.other': 'Sonstige …',
  'fabric.editor.outdent': 'Einzug verkleinern',
  'fabric.editor.overflowMenuViewMore': 'Mehr anzeigen',
  'fabric.editor.pageActionsLabel': 'Seitenaktionen',
  'fabric.editor.panel': 'Panel',
  'fabric.editor.panel.backgroundColor': 'Hintergrundfarbe',
  'fabric.editor.panel.custom': 'Benutzerdefiniert',
  'fabric.editor.panel.emoji': 'Emoji hinzufügen',
  'fabric.editor.panel.panelsGroup': 'Panel-Typen',
  'fabric.editor.panelButtonTitle': 'Panel',
  'fabric.editor.pasteOptions': 'Optionen zum Einfügen',
  'fabric.editor.pastePlainText': 'Einfachen Text einfügen',
  'fabric.editor.placeholderAltText': 'Dieses Bild mit Alternativtext beschreiben',
  'fabric.editor.placeholderText': 'Platzhaltertext',
  'fabric.editor.placeholderText.description': 'Textplatzhalter in die Seite einfügen',
  'fabric.editor.placeholderTextPlaceholder': 'Platzhaltertext hinzufügen',
  'fabric.editor.plainText': 'Nur-Text verwenden',
  'fabric.editor.preferencesLink': 'Verknüpfungseinstellungen',
  'fabric.editor.previewButtonTitle': 'Vorschau',
  'fabric.editor.quickInsert': 'Schnelleinfügung',
  'fabric.editor.recordLoomShortTitle': 'Aufzeichnen',
  'fabric.editor.recordVideo': 'Loom-Video aufnehmen',
  'fabric.editor.recordVideo.description': 'Nehmen Sie Ihren Bildschirm und Ihre Gedanken auf und teilen Sie sie.',
  'fabric.editor.redo': 'Wiederherstellen',
  'fabric.editor.remove': 'Entfernen',
  'fabric.editor.removeColumns': '{0, plural, one {Spalte löschen} other {Spalten löschen}}',
  'fabric.editor.removeEmoji': 'Emoji entfernen',
  'fabric.editor.removeImageBorder': 'Rahmen entfernen',
  'fabric.editor.removeRows': '{0, plural, one {Zeile löschen} other {Zeilen löschen}}',
  'fabric.editor.replace': 'Ersetzen',
  'fabric.editor.replaceAll': 'Alle ersetzen',
  'fabric.editor.replaceSuccess':
    '{numberOfMatches, plural, one {{numberOfMatches,number} Übereinstimmung ersetzt} other {{numberOfMatches,number} Übereinstimmungen ersetzt}}',
  'fabric.editor.replaceWith': 'Ersetzen mit',
  'fabric.editor.requestToEdit': 'Für Bearbeitung anfragen',
  'fabric.editor.requestToEditDescription':
    'Wenn Sie Zugriff anfordern, erhält der Seitenbesitzer eine Benachrichtigung.',
  'fabric.editor.requestToEditDismiss': 'Schließen',
  'fabric.editor.resizeHandle': 'Ziehpunkt zur Größenänderung',
  'fabric.editor.resultsCount': '{selectedMatchPosition} von {totalResultsCount}',
  'fabric.editor.richText': 'Rich Text verwenden',
  'fabric.editor.rightSidebar': 'Layout der rechten Seitenleiste',
  'fabric.editor.rowControl': 'Zeile hervorheben',
  'fabric.editor.rowDragHandle': 'Zeilenoptionen',
  'fabric.editor.rowMovedDown': 'Zeile nach unten verschoben auf {index} von {total}',
  'fabric.editor.rowMovedUp': 'Zeile nach oben verschoben auf {index} von {total}',
  'fabric.editor.rowSelected': 'Zeile {index} von {total} ausgewählt',
  'fabric.editor.rowsAreInserted':
    '{count, plural, one {Eine Zeile wurde eingefügt.} other {{count} Zeilen wurden eingefügt.}}',
  'fabric.editor.rowsAreRemoved':
    '{count, plural, one {Die Zeile wurde entfernt.} other {{count} Zeilen wurden entfernt.}}',
  'fabric.editor.saveButton': 'Speichern',
  'fabric.editor.searchResults':
    '{itemsLength, plural, one {{itemsLength,number} Suchergebnis verfügbar. Benutzen Sie die Pfeiltasten nach oben und unten, um zwischen den Optionen zu navigieren. Drücken Sie die Eingabetaste, um eine Option auszuwählen.} other {{itemsLength,number} Suchergebnisse verfügbar. Benutzen Sie die Pfeiltasten nach oben und unten, um zwischen den Optionen zu navigieren. Drücken Sie die Eingabetaste, um eine Option auszuwählen.}}',
  'fabric.editor.selectColumnResize': 'Spaltengröße auswählen',
  'fabric.editor.selectLanguage': 'Sprache auswählen',
  'fabric.editor.selectTableColumn': 'Spalte auswählen',
  'fabric.editor.selectTableRow': 'Zeile auswählen',
  'fabric.editor.selectionExtensionDropdownButtonLabel': 'App auswählen',
  'fabric.editor.selectionToolbarOverflowMenuTooltip': 'Weitere Optionen',
  'fabric.editor.settingsLinks': 'Zu den Link-Einstellungen',
  'fabric.editor.shortEmptyNodePlaceholderText': '/ eingeben, um etwas einzufügen',
  'fabric.editor.shortcut': 'Textverknüpfung',
  'fabric.editor.single': 'Layout mit einer Spalte',
  'fabric.editor.singleColumns': 'Layout mit 1 Spalte',
  'fabric.editor.sortColumnASC': 'Spalte sortieren: A → Z',
  'fabric.editor.sortColumnDESC': 'Spalte sortieren: Z → A',
  'fabric.editor.sortColumnDecreasing': 'Absteigend sortieren',
  'fabric.editor.sortColumnIncreasing': 'Aufsteigend sortieren',
  'fabric.editor.splitCell': 'Zelle teilen',
  'fabric.editor.status': 'Status',
  'fabric.editor.status.description': 'Benutzerdefiniertes Status-Label hinzufügen',
  'fabric.editor.statusEditorLabel': 'Status-Editor',
  'fabric.editor.statusPickerOpenedAlert':
    'Pop-up des Statuseditors wurde geöffnet. Drücken Sie die Tabulatortaste, um das Pop-up aufzurufen.',
  'fabric.editor.statusPlaceholder': 'Status festlegen',
  'fabric.editor.story': 'Story',
  'fabric.editor.strike': 'Durchgestrichen',
  'fabric.editor.subTask': 'Sub-Task',
  'fabric.editor.subscript': 'Tiefgestellt',
  'fabric.editor.subscript.off.superscript.on': 'Tiefgestelltes Zeichen aus, hochgestelltes Zeichen ein',
  'fabric.editor.success': 'Erfolgreich',
  'fabric.editor.successPanel': 'Erfolgs-Panel',
  'fabric.editor.successPanel.description': 'Tipps in einem farbigen Panel einfügen',
  'fabric.editor.superscript': 'Hochgestellt',
  'fabric.editor.superscript.off.subscript.on': 'Hochgestelltes Zeichen aus, tiefgestelltes Zeichen ein',
  'fabric.editor.supportAltText':
    'Alternativtexte sind eine Hilfe für Personen, die aufgrund ihrer eingeschränkten Sehfähigkeit Screenreader nutzen.',
  'fabric.editor.table': 'Tabelle',
  'fabric.editor.table.description': 'Tabelle einfügen',
  'fabric.editor.tableAlignmentOptions': 'Ausrichtungsoptionen',
  'fabric.editor.tableFullWidthLabel': 'Volle Breite',
  'fabric.editor.tableHeader.sorting.asc': 'Aufsteigend sortiert',
  'fabric.editor.tableHeader.sorting.default': 'Spalte sortieren',
  'fabric.editor.tableHeader.sorting.desc': 'Absteigend sortiert',
  'fabric.editor.tableHeader.sorting.invalid': 'Tabellen mit zusammengeführten Zellen können nicht sortiert werden.',
  'fabric.editor.tableHeader.sorting.no': 'Keine Sortierung auf die Spalte angewendet',
  'fabric.editor.tableOptions': 'Tabellenoptionen',
  'fabric.editor.tableResizeDecreaseScreenReaderInformation':
    '{newWidth, plural, one {Die Tabellenbreite wurde auf {newWidth,number} Pixel verringert.} other {Die Tabellenbreite wurde auf {newWidth,number} Pixel verringert.}}',
  'fabric.editor.tableResizeIncreaseScreenReaderInformation':
    '{newWidth, plural, one {Die Tabellenbreite wurde auf {newWidth,number} Pixel erhöht.} other {Die Tabellenbreite wurde auf {newWidth,number} Pixel erhöht.}}',
  'fabric.editor.tableScrollRegion': 'Scrollbarer Bereich der Tabelle',
  'fabric.editor.tableSelector': 'Tabellengröße',
  'fabric.editor.tableSelector.description':
    'Fügen Sie eine Tabelle hinzu und wählen Sie im Popup-Fenster eine benutzerdefinierte Größe aus.',
  'fabric.editor.tableSizeSelectorButton': '{numberOfColumns} von {numberOfRows}',
  'fabric.editor.tableSizeSelectorPopup': 'Auswahl der Tabellengröße',
  'fabric.editor.tables.adjustColumn': 'Spalte anpassen',
  'fabric.editor.tables.columnResizeLast': 'Sie können die Größe dieser Spalte nur nach links ändern.',
  'fabric.editor.tables.columnResizeOverflow':
    'Sie können die Größe dieser Spalte nur ändern, wenn die Tabelle eine Scrollleiste hat.',
  'fabric.editor.tables.columnWidth':
    '{width, plural, one {Die Spaltenbreite wurde auf {width} Pixel geändert} other {Die Spaltenbreite wurde auf {width} Pixel geändert}}',
  'fabric.editor.tables.confirmDeleteLinkedModalMessage':
    'Durch das Löschen von {nodeName} werden alle damit verbundenen Elemente unbrauchbar.',
  'fabric.editor.tables.confirmDeleteLinkedModalOKButton': 'Löschen',
  'fabric.editor.tables.resizeStop': 'Größenänderung beendet',
  'fabric.editor.tables.resizeTable': 'Tabellengröße ändern',
  'fabric.editor.tables.startedColumnResize': 'Größenänderung der Spalte gestartet',
  'fabric.editor.task': 'Task',
  'fabric.editor.taskDecision.markTaskAsCompleted': 'Aufgabe als abgeschlossen markieren',
  'fabric.editor.taskDecision.markTaskAsNotCompleted': 'Aufgabe als nicht abgeschlossen markieren',
  'fabric.editor.taskList': 'Aufgabenliste',
  'fabric.editor.taskPlaceholder': 'Geben Sie Ihre Aktion ein und weisen Sie sie mithilfe von „@” jemandem zu.',
  'fabric.editor.text.formatting.off': 'Textformatierung aus',
  'fabric.editor.textColor': 'Textfarbe: {selectedColorName}',
  'fabric.editor.textColorHighlightTooltip': 'Farbe für Text und Hervorhebungen',
  'fabric.editor.textColorTooltip': 'Textfarbe',
  'fabric.editor.textFormat': 'Text formatieren',
  'fabric.editor.textFormatting': 'Textformatierung',
  'fabric.editor.textStyles': 'Textstile: {blockTypeName}',
  'fabric.editor.textStylesTooltip': 'Textstile',
  'fabric.editor.threeColumns': 'Layout mit 3 Spalten',
  'fabric.editor.threeColumnsWithLeftSidebars': 'Layout mit drei Spalten und Seitenleiste links',
  'fabric.editor.threeColumnsWithRightSidebars': 'Layout mit drei Spalten und Seitenleiste rechts',
  'fabric.editor.threeColumnsWithSidebars': 'Layout mit drei Spalten und Seitenleisten',
  'fabric.editor.time.ago': 'vor',
  'fabric.editor.time.updated': 'Aktualisiert',
  'fabric.editor.time.viewed': 'Angesehen',
  'fabric.editor.toolbarAppears': 'Symbolleiste wird angezeigt',
  'fabric.editor.toolbarLabel': 'Editor',
  'fabric.editor.toolbarMediaTitle': 'Bild, Video oder Datei hinzufügen',
  'fabric.editor.toolbarPositionFixedAtTop': 'Oben fixiert',
  'fabric.editor.toolbarPositionInline': 'Auf gleicher Höhe wie der Text',
  'fabric.editor.toolbarPositionPinedAtTop': 'Symbolleiste lösen',
  'fabric.editor.toolbarPositionUnpined': 'Symbolleiste oben anheften',
  'fabric.editor.toolbarPositionUnpinnedConcise': 'Symbolleiste oben anheften',
  'fabric.editor.tooltip.blockPanel': 'ein Panel',
  'fabric.editor.tooltip.bulletList': 'eine Liste',
  'fabric.editor.tooltip.decisionList': 'eine Entscheidungsliste',
  'fabric.editor.tooltip.defaultBlockNode': 'ein Blockknoten',
  'fabric.editor.tooltip.nestedExpand': 'eine verschachtelte Erweiterung',
  'fabric.editor.tooltip.taskList': 'eine Aufgabe',
  'fabric.editor.turnInto': 'Verwandeln in',
  'fabric.editor.twoColumns': 'Layout mit 2 Spalten',
  'fabric.editor.typeAhead.popupLabel': 'Ergebnisse der Vorschlagsfunktion',
  'fabric.editor.typeAhead.quickInsertInputLabel':
    'Beginnen Sie die Eingabe, um nach Optionen für Tastenkombinationen zu suchen oder diese zu filtern',
  'fabric.editor.typeAhead.quickInsertInputPlaceholderLabel': 'Suchen',
  'fabric.editor.typeAhead.quickInsertPopupLabel': 'Tastenkombination für Einfügungen und Formatierung',
  'fabric.editor.typeAheadErrorFallbackDescription': 'Es sind keine Ergebnisse verfügbar. Versuchen Sie es erneut.',
  'fabric.editor.typeAheadErrorFallbackHeading': 'Es ist ein Fehler aufgetreten',
  'fabric.editor.typeahead.emojiInputLabel':
    'Beginnen Sie mit der Eingabe, um nach Optionen für Emojis zu suchen oder diese zu filtern',
  'fabric.editor.typeahead.emojiListItemLabel': 'Emoji {name} Tastenkombination für Text {shortcut}',
  'fabric.editor.typeahead.emojiPopupLabel': 'Tastenkombinationen für Emojis',
  'fabric.editor.typeahead.mentionInputLabel':
    'Beginnen Sie mit der Eingabe, um nach Benutzern zum Kennzeichnen zu suchen',
  'fabric.editor.typeahead.mentionPopupLabel': 'Benutzer, die Sie kennzeichnen können',
  'fabric.editor.typeahead.metionListItemLabel': 'Benutzer {name} @{shortName}',
  'fabric.editor.unableToLoadContent': 'Der Inhalt konnte nicht geladen werden',
  'fabric.editor.unableToOpenLink': 'Dieser Link konnte nicht geöffnet werden.',
  'fabric.editor.underline': 'Unterstrichen',
  'fabric.editor.undo': 'Rückgängig machen',
  'fabric.editor.unknown.label': 'Unbekannt',
  'fabric.editor.unlink': 'Verknüpfung löschen',
  'fabric.editor.unorderedList': 'Aufzählung',
  'fabric.editor.unorderedList.description': 'Unsortierte Liste erstellen',
  'fabric.editor.unsupportedBlockContent': 'Dieser Editor unterstützt die Anzeige dieses Inhalts nicht',
  'fabric.editor.unsupportedContentTooltip':
    'Der Inhalt ist in diesem Editor nicht verfügbar, dies bleibt durch Bearbeiten und Speichern erhalten.',
  'fabric.editor.unsupportedInlineContent': 'Nicht unterstützter Inhalt',
  'fabric.editor.upDown':
    'Bei Verwendung der Aufwärts- und Abwärtspfeiltasten im folgenden Eingabefeld wird das Datum unten aktualisiert',
  'fabric.editor.url': 'URL anzeigen',
  'fabric.editor.urlDescription': 'Link als URL anzeigen',
  'fabric.editor.urlTitle': 'URL',
  'fabric.editor.useMarkdown': 'Markdown verwenden',
  'fabric.editor.viewAndAddCommentsOnMedia': 'Kommentare anzeigen und hinzufügen',
  'fabric.editor.viewCommentOnMedia': 'Kommentare anzeigen',
  'fabric.editor.viewMore': 'Mehr anzeigen',
  'fabric.editor.viewMoreAriaLabel': 'Alle Elemente anzeigen',
  'fabric.editor.visit': 'Link in neuem Fenster öffnen',
  'fabric.editor.warning': 'Warnung',
  'fabric.editor.warningPanel': 'Warn-Panel',
  'fabric.editor.warningPanel.description': 'Hinweis zur Vorsicht in einem farbigen Panel einfügen',
  'fabric.editor.wrapLeft': 'Links umwickeln',
  'fabric.editor.wrapRight': 'Rechts umwickeln',
  'fabric.emoji.label': 'Emoji',
  'fabric.theme.blue': 'Blau',
  'fabric.theme.bold-blue': 'Kräftiges Blau',
  'fabric.theme.bold-gray': 'Kräftiges Grau',
  'fabric.theme.bold-green': 'Kräftiges Grün',
  'fabric.theme.bold-magenta': 'Kräftiges Magenta',
  'fabric.theme.bold-orange': 'Kräftiges Orange',
  'fabric.theme.bold-purple': 'Kräftiges Violett',
  'fabric.theme.bold-red': 'Kräftiges Rot',
  'fabric.theme.bold-teal': 'Kräftiges Türkis',
  'fabric.theme.bold-yellow': 'Kräftiges Gelb',
  'fabric.theme.bolder-blue': 'Kräftigeres Blau',
  'fabric.theme.bolder-gray': 'Kräftigeres Grau',
  'fabric.theme.bolder-green': 'Kräftigeres Grün',
  'fabric.theme.bolder-magenta': 'Kräftigeres Magenta',
  'fabric.theme.bolder-orange': 'Kräftigeres Orange',
  'fabric.theme.bolder-purple': 'Kräftigeres Violett',
  'fabric.theme.bolder-red': 'Kräftigeres Rot',
  'fabric.theme.bolder-teal': 'Kräftigeres Türkis',
  'fabric.theme.bolder-yellow': 'Kräftigeres Gelb',
  'fabric.theme.dark-blue': 'Dunkelblau',
  'fabric.theme.dark-gray': 'Dunkelgrau',
  'fabric.theme.dark-green': 'Dunkelgrün',
  'fabric.theme.dark-purple': 'Dunkelviolett',
  'fabric.theme.dark-red': 'Dunkelrot',
  'fabric.theme.dark-teal': 'Dunkeltürkis',
  'fabric.theme.dark-yellow': 'Dunkelgelb',
  'fabric.theme.default': 'Standard',
  'fabric.theme.gray': 'Grau',
  'fabric.theme.green': 'Grün',
  'fabric.theme.light-blue': 'Hellblau',
  'fabric.theme.light-gray': 'Hellgrau',
  'fabric.theme.light-green': 'Hellgrün',
  'fabric.theme.light-purple': 'Hellviolett',
  'fabric.theme.light-red': 'Hellrot',
  'fabric.theme.light-teal': 'Helltürkis',
  'fabric.theme.light-yellow': 'Hellgelb',
  'fabric.theme.lime': 'Limettengrün',
  'fabric.theme.magenta': 'Magenta',
  'fabric.theme.no-color': 'Keine Hervorhebung',
  'fabric.theme.orange': 'Orange',
  'fabric.theme.purple': 'Violett',
  'fabric.theme.red': 'Rot',
  'fabric.theme.subtle-blue': 'Dezentes Blau',
  'fabric.theme.subtle-gray': 'Dezentes Grau',
  'fabric.theme.subtle-green': 'Dezentes Grün',
  'fabric.theme.subtle-magenta': 'Dezentes Magenta',
  'fabric.theme.subtle-orange': 'Dezentes Orange',
  'fabric.theme.subtle-purple': 'Dezentes Violett',
  'fabric.theme.subtle-red': 'Dezentes Rot',
  'fabric.theme.subtle-teal': 'Dezentes Türkis',
  'fabric.theme.subtle-yellow': 'Dezentes Gelb',
  'fabric.theme.teal': 'Türkis',
  'fabric.theme.white': 'Weiß',
  'fabric.theme.yellow': 'Gelb',
  'fabrid.editor.rowNumbers': 'Zeilennummern',
  'rovo.agents.dropdown.title': 'Agenten',
  'rovo.agents.dropdown.viewAgents.label': 'Alle Agenten anzeigen',
};
